<template>
  <v-layout justify-center>
    <v-flex xs10 md8>
      <v-card>
        <v-text-field label="message" v-model="message" v-on:keyup.enter="send"></v-text-field>
      </v-card>
      <br>
      <v-card>
        <pre>
          {{ ovenData }}
        </pre>
        <pre>
          {{ debug }}
        </pre>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  components: {},
  data: () => ({
    message: null
  }),
  computed: {
    ovenData() {
      return this.$store.state.ovenData;
    },
    debug() {
      return this.$store.state.debug;
    }
  },
  methods: {
    send() {
      this.$store.dispatch("send", this.message);
      this.message = null;
    }
  }
};
</script>

<style>

</style>
